// extracted by mini-css-extract-plugin
export var layoutHolder = "Layout-module--layoutHolder--2c14f";